import { configure } from 'mobx'

// MobX 6 defaults to strict action enforcement, throwing when an observable
// is mutated outside an @action. Several stores have plain (non-@action)
// setters in computed getter/setter pairs that would violate that default,
// so this preserves MobX 3's original loose-mutation behavior.
configure({ enforceActions: 'never' })
